<script setup>
import { useInstanceStore } from '@/store/backendInstances'
import { computed, onMounted, ref } from 'vue'
import { inputRequiredRule } from '@/composables/inputRules'
import { useExternalLink } from '@/composables/externalBrowser.js'
import { useEphemeralBackendInstancesStore } from '@/store/ephemeralBackendInstances.js'

const instanceStore = useInstanceStore()

const props = defineProps({
  globalUniqueIdentifier: { type: String, required: true },
})
const hasAccepted = defineModel('accepted', { type: Boolean, default: false })
const acceptedVersion = defineModel('version', { type: String })
const rules = [inputRequiredRule]

const checkbox = ref(null)

const currentEULA = computed(() => useEphemeralBackendInstancesStore().eulas[props.globalUniqueIdentifier]?.['current'])

onMounted(async () => {
  hasAccepted.value = false
  if (!currentEULA.value) await instanceStore.getCurrentEula(props.globalUniqueIdentifier)
  acceptedVersion.value = currentEULA.value.version
})
</script>

<template>
  <v-checkbox
    v-if="currentEULA"
    ref="checkbox"
    v-model="hasAccepted"
    :rules="rules"
    density="comfortable"
  >
    <template #label>
      {{ $t('eula.accept_text') }}
      <v-btn
        target="_blank"
        variant="text"
        @click.stop
        @click="useExternalLink(currentEULA.url)"
      >
        {{ $t('eula.eula') }}
      </v-btn>
    </template>
  </v-checkbox>
  <v-skeleton-loader
    v-else
    type="subtitle"
  />
</template>
<style scoped></style>
